import { useRequest } from 'ahooks'
import { Button } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { getPointPermission } from '@/components'
import { JQLTable, JiraResp } from '@/components/jql/jql-table.component'
import { JiraColumnProps } from '@/modules/project/project-detail/project-jql/project-jql-table-config.component'
import { PAGE_RESOURCE_POINTS_ENUM, ResourceType } from '@/schemas'

import { Production } from '../../production.schema'
import { ProductionJQLEdit } from './production-jql-edit.component'
import { ProductionJqlTableConfig } from './production-jql-table-config.component'

interface ProductionJQLProps {
  production: Production
}

export const ProductionJQLContainer: React.FC<ProductionJQLProps> = ({ production }) => {
  const { t } = useTranslation()
  const { selfId, jql: initialJql } = production
  const { editable: editableConfig } = getPointPermission(
    PAGE_RESOURCE_POINTS_ENUM.需求与问题_配置,
    production.permissions
  )
  const { editable: editableContent } = getPointPermission(
    PAGE_RESOURCE_POINTS_ENUM.需求与问题_内容,
    production.permissions
  )
  const [editVisible, setEditVisible] = React.useState(false)
  const [configVisible, setConfigVisible] = React.useState(false)
  const [jql, setJql] = React.useState(initialJql)

  const {
    data: jiraTableData,
    run: jiraTableRefresh,
    loading: jiraTableLoading,
  } = useRequest<JiraColumnProps[]>(() => ({
    url: '/api/project/getJiraTableConfig',
    method: 'get',
    params: {
      selfId,
      type: ResourceType.PRODUCTION,
    },
  }))

  const { data, loading, run } = useRequest<JiraResp>(
    {
      url: '/api/project/getJiraAndUpdate',
      params: {
        selfId: production.selfId,
        type: ResourceType.PRODUCTION,
        jql,
      },
    },
    {
      manual: true,
      refreshOnWindowFocus: false,
      debounceInterval: 800,
    }
  )

  // ready和refreshDeps配合时只会在第一次生效
  // https://github.com/alibaba/hooks/issues/468
  React.useEffect(() => {
    if (jql) {
      run()
    }
  }, [jql])

  const issues = data?.issues || []
  const hasBugField = issues.some((issue) => issue.bugResolved !== 'N/A')
  const hasReleaseStatusField = issues.some((issue) => issue.isReleaseType)

  // const menu = (
  //   <Menu>
  //     <Menu.Item disabled={!canUpdate} >
  //       {t('configure jql')}
  //     </Menu.Item>
  //     {/* <Menu.Item disabled={!canUpdate} onClick={() => setSearchVisible(true)}>
  //       {t('search jql')}
  //     </Menu.Item> */}
  //   </Menu>
  // )

  const dropdown = (
    <div className='flex mb-4 justify-between'>
      <Button type='primary' disabled={!editableConfig} onClick={() => setConfigVisible(true)}>
        {t('list config')}
      </Button>
      {/* <Dropdown overlay={menu}> */}
      <Button type='primary' disabled={!editableContent} onClick={() => setEditVisible(true)}>
        {t('associate jira')}
      </Button>
      {/* </Dropdown> */}
    </div>
  )

  const table = jql && (
    <JQLTable
      columns={jiraTableData || []}
      issues={issues}
      loading={loading || jiraTableLoading}
      entity={{ name: production.name, type: ResourceType.PRODUCTION }}
    />
  )

  return (
    <div>
      {dropdown}
      {table}
      <ProductionJQLEdit
        columns={jiraTableData || []}
        selfId={selfId}
        jql={jql}
        onSuccess={setJql}
        visible={editVisible}
        setVisible={setEditVisible}
        production={production}
      />
      <ProductionJqlTableConfig
        columns={jiraTableData || []}
        selfId={selfId}
        visible={configVisible}
        setVisible={setConfigVisible}
        refresh={jiraTableRefresh}
        hasBugField={hasBugField}
        hasReleaseStatusField={hasReleaseStatusField}
      />
    </div>
  )
}
